import { DesignData } from 'editor/src/store/design/types';

import collectVariableDataBindings from './collectVariableDataBindings';

/** Whether any element prints or encodes a code-set column. The design-level
 *  binding alone does not count: a set chosen with nothing bound to it prints
 *  N identical copies like any other design. */
function hasVariableDataBindings(designData: DesignData | undefined): boolean {
  const { texts, qrFields } = collectVariableDataBindings(designData);
  return texts.length > 0 || qrFields.length > 0;
}

export default hasVariableDataBindings;
